import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import MuiDataTable from "../../../../components/Table/MuiDataTable/MuiDataTable";
import { useSnackbar } from "@livingdesign/react";
import AFAPortfolioListStyles from "./AFAPortfolioList.styles";
import { postService } from "../../../../axios/axios";
import { COMPOSITE_SEARCH_SERVICE } from "../../../../constants/baseURLs";
import { CS_IS_ACTIVE_FILTER, CS_SCOPES, PORTFOLIO_MATTER_DEFAULT_SORT_QUERY } from "../../../../constants/constants";
import { formCompositeSearchQuery, formCsPaginationQuery } from "../../../../helpers/csQueryUtils";
import { getErrorMessage } from "../../../../helpers/utils";
import { ROWS_PER_PAGE_OPTIONS_PORTFOLIO, ROWS_PER_PAGE_PORTFOLIO } from "../../../../constants/tableConfigs";
import { formCsSortQuery } from "../../../../helpers/csQueryUtils";
import { getAllowedActionsList } from "../../../../helpers/tableUtils";
import { useSelector } from "react-redux";

const AFAPortfolioList = () => {
    const history = useHistory();
    const classes = AFAPortfolioListStyles();
    const matterAccessibility = useSelector((state) => state?.accessibility?.applicationAccess?.matters?.portfolio);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [rowsPerPagePortfolio, setRowsPerPagePortfolio] = useState(ROWS_PER_PAGE_PORTFOLIO);
    const [page, setPage] = useState(0);
    const [filterQuery, setFilterQuery] = useState([]);
    const [sortQuery, setSortQuery] = useState(PORTFOLIO_MATTER_DEFAULT_SORT_QUERY);
    const { identifier } = useSelector((state) => state?.organization?.organizationDetailValues);

    const { addSnack } = useSnackbar();

    const FILTER_CONFIGS = [
        {
            colKey: "portfolioName",
            type: "textField",
            label: "Portfolio Name",
        },
        {
            colKey: "portfolioCode",
            type: "textField",
            label: "Portfolio Code",
        },
        {
            colKey: "createdBy",
            type: "peopleDropdownAutocomplete",
            label: "Owner",
        },
    ];

    const handleServerSidePagination = ({ rowsPerPage, page: pageNumber }) => {
        let prevPage = page;
        if (rowsPerPagePortfolio !== rowsPerPage) {
            pageNumber = 0;
            prevPage = 0;
        }
        setPage(pageNumber);
        setRowsPerPagePortfolio(rowsPerPage);
    };

    const handleServerSideFilter = (filters) => {
        setFilterQuery(filters);
    };

    const handleServerSideSort = ({ name, direction }) => {
        const sortQuery = formCsSortQuery(name, direction);
        setSortQuery(sortQuery);
    };

    const getPortfolioData = () => {
        setLoading(true);
        const defaultQuery = {
            "filters": [
                CS_IS_ACTIVE_FILTER,
                {
                    "key": "organizations.id",
                    "value": identifier,
                    "operation": "match"
                }
            ],
            "operation": "AND",
            "properties": null
        }
        let paginationQuery = formCsPaginationQuery(rowsPerPagePortfolio, (rowsPerPagePortfolio * page));
        const query = formCompositeSearchQuery([CS_SCOPES.PORTFOLIO], filterQuery, {}, sortQuery, paginationQuery, {}, defaultQuery, {});
        postService(
            COMPOSITE_SEARCH_SERVICE,
            `/composite-search/v1?returnCsv=false`,
            query
        )
            .then((response) => {
                setLoading(false);
                setData({
                    data: response?.data?.portfolio?.data || [],
                    count: response?.data?.portfolio?.count || 0
                });
            }).catch((error) => {
                setLoading(false)
                addSnack({
                    message: getErrorMessage(error)
                })
            })
    }
    useEffect(() => {
        getPortfolioData();
    }, [filterQuery, sortQuery, rowsPerPagePortfolio, page])

    const customOptions = {
        selectableRows: "none",
        responsive: "standard",
        rowsPerPage: rowsPerPagePortfolio,
        rowsPerPageOptions: ROWS_PER_PAGE_OPTIONS_PORTFOLIO,
        serverSide: true,
        onServerSidePagination: handleServerSidePagination,
        onServerSideFilter: handleServerSideFilter,
        onServerSideSort: handleServerSideSort,
        filterConfigs: FILTER_CONFIGS,
        totalCount: data?.count,
        enableServerSideFilter: true,
        enableServerSidePagination: true,
        enableServerSideSort: true,
        expandableRows: false,
        expandableRowsHeader: false,
        expandableRowsOnClick: false,
    };



    const COLUMNS = [
        {
            name: "portfolioName",
            label: "Portfolio Name",
            options: {
                filter: true,
                sort: true
            },
        },
        {
            name: "portfolioCode",
            label: "Portfolio Code",
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: "description",
            label: "Description",
            options: {
                filter: false,
                sort: false,
            },
        },
        {
            name: "createdBy",
            label: "Owner",
            options: {
                filter: false,
                sort: false,
            },
        },
        {
            name: "id",
            label: "Identifier",
            options: {
                filter: false,
                sort: false,
                display: false,
            },
        }
    ];


    const handleAddNew = () => {
        // Navigate to add new AFA portfolio page
        history.push('/afaPortfolio/add');
    };

    const handleRowClick = (rowData, rowMeta) => {
        history.push(`/afaPortfolio/${rowData?.[4]}/view`);
    }

    return (
        <div className={classes.dataTableWrap}>
            <MuiDataTable
                data={data?.data || []}
                columns={COLUMNS}
                customOptions={customOptions}
                onAddNew={handleAddNew}
                addNewLabel="New AFA Portfolio"
                disableExport={true}
                disableAddNew={false}
                hideAddNewButton={false}
                loading={loading}
                onRowClick={handleRowClick}
                allowedActions={getAllowedActionsList(matterAccessibility)}
                disableSearch={false}
                disableFilter={false}
                noResultsText="No AFA portfolios found"
            />
        </div>
    );
}

export default AFAPortfolioList;